import { getCookie } from './cookie';

export const defaultCultureCode = 'nl';

export const getCultureName = () => {
	return getCookie('culture') || `${defaultCultureCode}-${defaultCultureCode.toUpperCase()}`;
};

export const getCultureCode = () => {
	const cultureName = getCultureName();

	return cultureName.split('-')[0];
};

export const cultureCodeDecimal = {
	en: '.',
	nl: ',',
	pl: ',',
	de: ',',
	hr: ',',
	cs: ',',
	sk: ',',
};

export const getDecimalChar = () => {
	const cultureCode = getCultureCode();

	return cultureCodeDecimal[cultureCode] ? cultureCodeDecimal[cultureCode] : cultureCodeDecimal[defaultCultureCode];
};
